import { useState } from "react";
import { formatterCurrency, formatterDate } from "../../../shared/utils";

export default function GroupCard({ grupo }) {
    const [expanded, setExpanded] = useState(false);
    const { totais, diario, produtos } = grupo;
    const isNegativo = totais.lucro < 0;

    return (
        <div className="bg-surface-2 rounded-xl border border-white/[0.08] overflow-hidden">

            {/* Header do grupo */}
            <div className="p-4 border-b border-white/[0.08]">
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-bold">{grupo.nome}</h2>
                    <span className="text-sm text-ink-3">{totais.quantidade} vendas</span>
                </div>
            </div>

            {/* Cards de resumo */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 p-4">

                {/* Vendas */}
                <div className="bg-surface-1 rounded-lg p-4 border border-white/[0.08]">
                    <p className="text-xs text-ink-3 uppercase tracking-wider mb-1">Receita</p>
                    <p className="text-xl font-bold text-emerald-400">{formatterCurrency(totais.vendas)}</p>
                </div>

                {/* Investido */}
                <div className="bg-surface-1 rounded-lg p-4 border border-white/[0.08]">
                    <p className="text-xs text-ink-3 uppercase tracking-wider mb-1">Tráfego</p>
                    <p className="text-xl font-bold text-blue-400">{formatterCurrency(totais.investido)}</p>
                </div>

                {/* Lucro */}
                <div className="bg-surface-1 rounded-lg p-4 border border-white/[0.08]">
                    <p className="text-xs text-ink-3 uppercase tracking-wider mb-1">Lucro</p>
                    <p className={`text-xl font-bold ${isNegativo ? "text-red-500" : "text-emerald-400"}`}>
                        {formatterCurrency(totais.lucro)}
                    </p>
                </div>

            </div>

            {/* Cards de produtos */}
            <div className="px-4 pb-3">
                <p className="text-xs text-ink-3 uppercase tracking-wider mb-2">Produtos</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                    {produtos.map((p, i) => (
                        <div key={i} className="bg-surface-1/50 rounded-lg p-3 border border-white/[0.08] flex justify-between items-center">
                            <div>
                                <p className="text-sm font-medium">{p.nome}</p>
                                <p className="text-xs text-ink-3">{p.quantidade} vendas</p>
                            </div>
                            <p className="text-sm font-bold text-emerald-400">{formatterCurrency(p.vendas)}</p>
                        </div>
                    ))}
                    {produtos.length === 0 && <p className="text-sm text-ink-4">Nenhuma venda no período</p>}
                </div>
            </div>

            {/* Botão expandir tabela diária */}
            {diario.length > 0 && (
                <div className="px-4 pb-4">
                    <button
                        onClick={() => setExpanded(!expanded)}
                        className="text-sm text-brand-400 hover:text-brand-300 flex items-center gap-1"
                    >
                        {expanded ? "▼ Ocultar detalhamento diário" : "► Ver detalhamento diário"}
                    </button>

                    {expanded && (
                        <div className="mt-3 rounded-lg overflow-hidden border border-white/[0.08]">
                            <table className="w-full text-sm">
                                <thead className="bg-surface-3">
                                    <tr>
                                        <th className="p-3 text-left">Data</th>
                                        <th className="p-3 text-left">Investido</th>
                                        <th className="p-3 text-left">Receita</th>
                                        <th className="p-3 text-left">Lucro</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {diario.map((d, i) => {
                                        const lucro = (d.receita || 0) - (d.investido || 0);
                                        return (
                                            <tr key={i} className="border-t border-white/[0.08]">
                                                <td className="p-3">{formatterDate(d.data)}</td>
                                                <td className="p-3">{formatterCurrency(d.investido)}</td>
                                                <td className="p-3">{formatterCurrency(d.receita)}</td>
                                                <td className={`p-3 font-bold ${lucro < 0 ? "text-red-500" : "text-green-400"}`}>
                                                    {formatterCurrency(lucro)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot className="bg-surface-2">
                                    <tr>
                                        <th className="p-3 text-left">Totais</th>
                                        <th className="p-3 text-left">{formatterCurrency(totais.investido)}</th>
                                        <th className="p-3 text-left">{formatterCurrency(totais.vendas)}</th>
                                        <th className={`p-3 text-left font-bold ${isNegativo ? "text-red-500" : "text-green-400"}`}>
                                            {formatterCurrency(totais.lucro)}
                                        </th>
                                    </tr>
                                    {diario.length > 1 && (
                                        <tr>
                                            <th className="p-3 text-left">{`Médias (${diario.length} dias)`}</th>
                                            <th className="p-3 text-left">{formatterCurrency(totais.investido / diario.length)}</th>
                                            <th className="p-3 text-left">{formatterCurrency(totais.vendas / diario.length)}</th>
                                            <th className={`p-3 text-left ${totais.lucro / diario.length < 0 ? "text-red-500" : "text-green-400"}`}>
                                                {formatterCurrency(totais.lucro / diario.length)}
                                            </th>
                                        </tr>
                                    )}
                                </tfoot>
                            </table>
                        </div>
                    )}
                </div>
            )}

        </div>
    );
}
